import { Component, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { UserService } from '../../../service/user/user.service';
import { CommonService } from '../../../service/common/common.service';
import { RoleService } from '../../../service/role/role.service';
import { LogicalwhService } from '../../../service/logicalwh/logicalwh.service';
import { OwnerService } from 'app/service/owner/owner.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';
import { isAuthority } from '../../../util/util';

@Component({
  selector: 'wa9002',
  templateUrl: 'wa9002.component.html',
  styleUrls: ['wa9002.component.scss']
})
export class Wa9002Component implements AfterViewInit {
  public componentTitle = 'WA9002:ユーザマスタ登録';

  public logicalWhs: any;
  public roles: any;
  public owners: any;

  public userCd: FormControl;
  public userTx: FormControl;
  public langTx = 'ja';
  public passwordTx1: FormControl;
  public roleId: number = 0;
  public linkedOwnerId: number = 0;
  public logicalWhId: number = 0;

  public ownerActive = 'disabled';
  public isDisabledOnLinkedOwnerId = false ;
  public validation = validation;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;
  private isSubmitButtonEnabled = false;

  constructor(
    private router: Router,
    private userService: UserService,
    private logicalwhService: LogicalwhService,
    private roleService: RoleService,
    private ownerService: OwnerService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    // ユーザーコード
    this.userCd = new FormControl('', [
      // Validators.required,
      Validators.pattern(validation.userCdString)
    ]);

    // ユーザ名
    this.userTx = new FormControl('', [
      // Validators.required,
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.minLength(validation.userTx.minLength),
      Validators.maxLength(validation.userTx.maxLength)
    ]);

    // パスワード
    this.passwordTx1 = new FormControl('', [Validators.required, Validators.pattern(validation.password)]);

    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    // TODO should be execute parallel, but API server don't work properly
    // DONE.
    this.logicalwhService
      .get()
      .then(outputJson => {
        console.log(outputJson);
        this.logicalWhs = outputJson.logicalWhs;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.roleService
      .get()
      .then(_outputJson => {
        console.log(JSON.stringify(_outputJson));
        this.roles = _outputJson.roles;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.ownerService
      .get()
      .then(_outputJson => {
        console.log(JSON.stringify(_outputJson));
        this.owners = _outputJson.owners;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    let errors = false;
    if (!this.isSubmitButtonEnabled) return;
    if (this.userCd.errors !== null) {
      this.userCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.userTx.errors !== null) {
      this.userTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.passwordTx1.errors !== null) {
      this.passwordTx1.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }

    if (this.logicalWhId === undefined) {
      this.errorInfo = '論理倉庫を選択してください';
      return;
    }
    if (this.roleId === undefined) {
      this.errorInfo = '権限を選択してください';
      return;
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.userService
      .post(this.userCd.value, this.userTx.value.trim(), this.langTx, this.passwordTx1.value, this.roleId,this.linkedOwnerId, this.logicalWhId)
      .then(outputJson => {
        this.working = false;
        this.closeButtonClick.emit(true);
        
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.errorInfo = '';
      this.initDatas();
    } else {
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    this.userCd.setValue('');
    this.userTx.setValue('');
    this.passwordTx1.setValue('');
    this.ownerActive = 'disabled';
    this.roleId = undefined;
    this.logicalWhId = undefined;
    this.linkedOwnerId = null;
    this.isSubmitButtonEnabled = false;
  }

  cancel() {
    this.errorInfo = '';

    this.closeButtonClick.emit(false);
  }

  changes(event) {
    this.errorInfo = '';
  }

  ownerChange(){
    if (this.roleId == 3) {
      this.ownerActive = 'active';
      this.isDisabledOnLinkedOwnerId = false;
      this.isSubmitButtonEnabled = false;
    } else {
      this.ownerActive = 'disabled';
      this.isDisabledOnLinkedOwnerId = true;
      this.linkedOwnerId =null;
  }
  }
  ngDoCheck() {
    if (this.userCd.value !== '' && this.userTx.value !== '' && this.passwordTx1.value !== '' && this.roleId != undefined && this.logicalWhId != undefined　&& this.roleId !=3) {
      if (!this.userCd.errors && !this.userTx.errors && !this.passwordTx1.errors) this.isSubmitButtonEnabled = true;
      else
        this.isSubmitButtonEnabled = false;
    }else if(this.userCd.value !== '' && this.userTx.value !== '' && this.passwordTx1.value !== '' && this.roleId != undefined && this.logicalWhId != undefined　&& this.roleId ==3 && this.linkedOwnerId != null){
      if (!this.userCd.errors && !this.userTx.errors && !this.passwordTx1.errors) this.isSubmitButtonEnabled = true;
     else this.isSubmitButtonEnabled = false;
    } else this.isSubmitButtonEnabled = false;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9002/wa9002.component.ts